
export class BOPatientRiskFactor{
    id:number;
    tempId?:string;
    patientId:number;
    riskFactorType:string;
    riskFactorName:string;
    riskFactorDetail?:string;
}
